import React, { useState, useEffect } from "react";
import LoadingSpinner from "../../LoadingSpinner";
import { Icon } from "@iconify/react";
import "./Profile.css";

const ContactForm = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const handleRefresh = () => {
    window.location.reload();
  };

  const NaviconStyle = {
    marginRight: "10px",
    marginTop: "10px",
    marginLeft: "10px",
  };

  useEffect(() => {
    // Simulate connection check (you can replace with real API/iframe test)
    const checkConnection = async () => {
      try {
        // Quick fetch to test internet connection
        await fetch("https://www.google.com", { mode: "no-cors" });
        setIsLoading(false);
        setHasError(false);
      } catch (error) {
        setHasError(true);
        setIsLoading(false);
      }
    };

    checkConnection();
  }, []);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (hasError) {
    return (
      <div className="no-connection">
        <p>No internet connection. Please check your connection.</p>
        <button onClick={handleRefresh}>
          <Icon
            icon="mdi:refresh-circle"
            color="black"
            width="19"
            height="19"
            style={NaviconStyle}
          />
          Reload
        </button>
      </div>
    );
  }

  return (
    <div>
      <button onClick={handleRefresh}>
        <Icon
          icon="mdi:refresh-circle"
          color="black"
          width="19"
          height="19"
          style={NaviconStyle}
        />
      </button>

      <iframe
        src={`https://www.spcommunity.org.za/user-profile?t=${Date.now()}`}
        style={{ width: "100%", height: "100vh", border: "none", overflow: "auto" }}
        title="Contact Form"
        onError={() => setHasError(true)}
      ></iframe>
    </div>
  );
};

export default ContactForm;



{/*
  
  import React, { useState, useEffect } from 'react';
import LoadingSpinner from '../../LoadingSpinner';
import { Link, useNavigate } from 'react-router-dom';
import { Icon } from '@iconify/react';
import "./Profile.css";

const ContactForm = () => {
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // Simulate data fetching
    setTimeout(() => {
      setIsLoading(false); // Stop spinner after fetching data
    }, 1000);
  }, []);

  const handleRefresh = () => {
  window.location.reload();
};

const NaviconStyle = {
    marginRight: '10px', // Margin between icon and text
    marginTop: '10px',
    marginLeft: '10px',
  };



   return isLoading ? (
    <LoadingSpinner />
  ) : (
    <div>
      <button onClick={handleRefresh} >
  <Icon icon="mdi:refresh-circle" color="black" width="19" height="19" style={NaviconStyle}/> 
    </button>
      {isLoading ? (
  <LoadingSpinner />
) : (

  <iframe
  src={`https://www.spcommunity.org.za/user-profile?t=${Date.now()}`}
  style={{ width: "100%", height: "100vh", border: "none", overflow: "auto" }}
  title="Contact Form"
  onLoad={() => setIsLoading(false)}
></iframe>



      
       )}

       {isLoading && <LoadingSpinner />}
    </div>
  ); 
  
};

export default ContactForm;

*/}
